import React from 'react';
import _ from 'lodash';
import { ViewModelForm, useDataRefresh} from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import htmlParser from 'html-react-parser';
import PropTypes from 'prop-types';
import metadata from './VerbalAuthorizationComponent.metadata.json5';
import messages from './VerbalAuthorizationComponent.messages';
import styles from './VerbalAuthorizationComponent.module.scss';

const VAFormScriptContentComponent = ({html}) => {
    let parsedHtml;
    try{
        parsedHtml = htmlParser(html);
    }catch(e){
        console.error(e);
        parsedHtml = html;
    }
    return (
        <React.Fragment>
            {parsedHtml}
        </React.Fragment>
    )
}

const VerbalAuthorizationComponent = (props) => {
    const { verbalAuthForms, convertDateToUTC } = props;

    const translator = useTranslator();
    const { refreshData } = useDataRefresh();

    const generateVaFormsOverrides = () => {
        const overrides = verbalAuthForms.map((vaForm, index) => {
            return {
                [`vaFormDescription${index}`] :{
                    content: vaForm.formDescription.value
                },
                [`vaFormScriptContent${index}`] :{
                    html: vaForm.agentScript.value
                },
                [`vaFormSignedContainer${index}`] :{
                    visible: vaForm.isSigned.value
                },
                [`vaFormSignedDateTime${index}`] :{
                    content: `${convertDateToUTC(vaForm.signedDateTime.value)} ${translator(messages.ut)}`
                },
                [`vaFormNotSignedContainer${index}`] :{
                    visible: !vaForm.isSigned.value
                },
                [`vaFormAcceptCheckbox${index}`] :{
                    value: vaForm.isSigned.value,
                    onValueChange: (value) => {
                        _.set(vaForm, 'isSigned.value', value);
                        _.set(vaForm, 'signedDateTime.value', new Date());
                        _.set(vaForm, 'signatureType', 'verbal');
                        refreshData();
                    }
                }
            }
        });

        return Object.assign({}, ...overrides);
    };

    const overrideProps  = {
        vaFormsIterable: {
            data: verbalAuthForms
        },
        ...generateVaFormsOverrides()
    };

    const resolvers = {
        resolveComponentMap: {
            vaFormScriptContentComponent: VAFormScriptContentComponent
        },   
        resolveClassNameMap: styles
    };
    
    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
};

VerbalAuthorizationComponent.propTypes = {
    verbalAuthForms: PropTypes.array.isRequired,
    convertDateToUTC: PropTypes.func.isRequired
};

export default VerbalAuthorizationComponent;
